import { style } from 'typestyle'
export const pb4 = style({ paddingBottom: '4px' })
